import { Grid, Stack, Typography } from "@mui/material";
import FileTile from "./FileTile";
import { FileAction, FileData } from "context/GameContext";

interface Props {
	files: FileData[];
	selectedFileIds?: string[];
	handleFileAction?: (file: FileData, action: FileAction) => void;
}

export default function FileBrowser(props: Props) {
	const { files, handleFileAction, selectedFileIds } = props;

	return (
		<Grid container spacing={"8px"} sx={{ padding: "24px" }} flexWrap="wrap">
			{files.length === 0 && (
				<Stack direction={"row"} justifyContent={"center"} width={"100%"} marginTop={"20px"}>
					{/* TODO: #loc */}
					<Typography>Empty</Typography>
				</Stack>
			)}
			{files.map((item) => (
				<Grid item xs={4} md="auto" key={item.id}>
					<FileTile
						fileData={item}
						selected={selectedFileIds?.includes(item.id)}
						onClick={() => handleFileAction?.(item, FileAction.CLICK)}
						onDoubleClick={() => handleFileAction?.(item, FileAction.DOUBLE_CLICK)}
					/>
				</Grid>
			))}
		</Grid>
	);
}
